"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateStyle = void 0;
const calculateStyle = (itemIndex, selectedItemIndex, loop, centered, childrenLength) => {
    if (selectedItemIndex === itemIndex) {
        return 0;
    }
    if (loop && childrenLength) {
        if (centered) {
            if (itemIndex === selectedItemIndex + 1) {
                return { transform: `translateX(${(itemIndex - selectedItemIndex) * 105}%)`, opacity: 1 };
            }
            if (itemIndex === selectedItemIndex - 1) {
                return {
                    transform: `translateX(${-(selectedItemIndex - itemIndex) * 105}%)`,
                    opacity: 1,
                };
            }
            if (selectedItemIndex === 0 && itemIndex === childrenLength - 1) {
                return { transform: "translateX(-105%)", opacity: 1 };
            }
            if (selectedItemIndex === childrenLength - 1 && itemIndex === 0) {
                return { transform: "translateX(105%)", opacity: 1 };
            }
        }
        if (selectedItemIndex === 0 && itemIndex === childrenLength - 1) {
            return { transform: "translateX(-105%)" };
        }
        if (selectedItemIndex === childrenLength - 1 && itemIndex === 0) {
            return { transform: "translateX(105%)" };
        }
    }
    /* TODO: fix the animation for loop centered */
    return itemIndex > selectedItemIndex && !centered
        ? {
            transform: `translateX(${-(selectedItemIndex - itemIndex) * 105}%)`,
            opacity: loop ? 0 : 1,
        }
        : {
            transform: `translateX(${(itemIndex - selectedItemIndex) * 105}%)`,
            opacity: loop ? 0 : 1,
        };
};
exports.calculateStyle = calculateStyle;
